import React from "react";
import { Button } from "@mui/material";
import { MOBILE_TOUCH_MIN_PX } from "../../theme/mobileLayout";

export default function OnboardingSkipButton({ onClick, compact = false, disabled = false }) {
  return (
    <Button
      type="button"
      variant="text"
      onClick={onClick}
      disabled={disabled}
      data-testid="onboarding-skip"
      sx={{
        minHeight: compact ? 32 : MOBILE_TOUCH_MIN_PX,
        minWidth: compact ? undefined : 72,
        px: compact ? 1 : 1.75,
        borderRadius: "8px",
        textTransform: "none",
        fontWeight: 600,
        fontSize: compact ? 13 : 13.5,
        color: "#4A2CF5",
        "&:hover": { backgroundColor: "rgba(74, 44, 245, 0.08)" },
      }}
    >
      Skip
    </Button>
  );
}
